/*
 * Trigger messages: the bubble that shows up by itself on the website.
 * Sites with a chat button of their own can take the message as an event
 * instead and show it their way, or switch triggers off.
 */

/** "bubble" shows our bubble, "events" only fires trigger_shown, "off" stops triggers. */
export type TriggerMode = "bubble" | "events" | "off";

/** Reads the triggers option, from the SDK or from the script tag's data-triggers. */
export function parseTriggerMode(value: unknown): TriggerMode {
  if (value === false) return "off";
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (["false", "off", "0", "no", "none"].includes(normalized)) return "off";
    if (normalized === "events") return "events";
  }
  return "bubble";
}

/** The option value for a mode, the way BitPalmAgentOptions takes it. */
export function triggersOption(mode: TriggerMode): boolean | "events" {
  return mode === "off" ? false : mode === "events" ? "events" : true;
}

export interface TriggerBubbleOptions {
  message: string;
  zIndex: number;
  /** Distance from the bottom edge: above the launcher, or lower without one. */
  bottom: number;
  onEngage: () => void;
  onDismiss: () => void;
}

/** The bubble on the website. The message goes in as text, never as HTML. */
export function createTriggerBubble(d: Document, options: TriggerBubbleOptions): HTMLDivElement {
  const bubble = d.createElement("div");
  bubble.setAttribute("data-bitpalm-trigger", "");
  bubble.style.cssText = `max-width:240px;background:#fff;border-radius:16px;padding:12px 32px 12px 12px;box-shadow:0 2px 20px rgba(0,0,0,0.08);cursor:pointer;z-index:${options.zIndex - 1};font-family:system-ui,sans-serif;animation:_bp_fade .3s;`;
  bubble.style.position = "fixed";
  bubble.style.right = "24px";
  bubble.style.bottom = `${options.bottom}px`;

  const text = d.createElement("p");
  text.style.cssText = "font-size:14px;color:#1f2937;margin:0;";
  text.textContent = options.message;

  const arrow = d.createElement("div");
  arrow.style.cssText = "position:absolute;bottom:-8px;right:20px;width:0;height:0;border-left:8px solid transparent;border-right:8px solid transparent;border-top:8px solid #fff;";

  const close = d.createElement("button");
  close.type = "button";
  close.setAttribute("aria-label", "Close");
  close.style.cssText = "position:absolute;top:-8px;right:-8px;width:28px;height:28px;border-radius:50%;background:#fff;border:none;box-shadow:0 1px 4px rgba(0,0,0,0.1);cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:14px;color:#9ca3af;";
  close.textContent = "✕";
  close.onclick = (event) => {
    event.stopPropagation();
    options.onDismiss();
  };

  bubble.onclick = () => options.onEngage();
  bubble.append(text, arrow, close);
  return bubble;
}
